import makeActionCreator from './makeActionCreator';
import { LOGOUT, LOGOUT_DONE, LOGOUT_FORCE, LOGOUT_LOADING } from './actionTypes';

export const logout = makeActionCreator(LOGOUT);
export const logoutLoading = makeActionCreator(LOGOUT_LOADING);
export const logoutDone = makeActionCreator(LOGOUT_DONE);
export const logoutForce = makeActionCreator(LOGOUT_FORCE);
